import { render, staticRenderFns } from "./candidate-details-modal.vue?vue&type=template&id=78f5599b&scoped=true&"
import script from "./candidate-details-modal.vue?vue&type=script&lang=js&"
export * from "./candidate-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./candidate-details-modal.vue?vue&type=style&index=0&id=78f5599b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5599b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems})
